module.exports = __webpack_public_path__ + "img/Salsa-Macha.fdf32a62.jpg";